<template>
  <div class="container text-center">
    <BaseTitle class="mt-8 has-text-primary">
      Inscription
    </BaseTitle>
    <BaseSuccessMessage>
      Merci, votre demande a été prise en compte.
      <br>
      Vous recevrez un email avec un lien pour choisir votre mot de passe.
    </BaseSuccessMessage>
    <b-button
      v-if="currentConfiguration.configuration_products.length"
      class="mr-4 button-bold"
      tag="router-link"
      to="/uni-baies/resume"
      type="is-info"
    >
      Revenir à la configuration
    </b-button>
    <b-button
      type="is-primary"
      tag="router-link"
      to="/uni-baies/configuration"
    >
      <strong>
        Créer une configuration
      </strong>
    </b-button>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import BaseTitle from '../components/BaseTitle.vue';
import BaseSuccessMessage from '../components/BaseSuccessMessage.vue';

export default {
  name: 'SignUpSuccess',
  components: {
    BaseSuccessMessage,
    BaseTitle,
  },
  computed: mapState('configuration', ['currentConfiguration']),
};
</script>
